"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultClassifierConfigurationTransferParams = void 0;
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
function useDefaultClassifierConfigurationTransferParams() {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return react_1.default.useMemo(() => [
        // please keep this list sorted
        {
            entityName: shared_1.ethnicityEntityName,
            label: t('defaultClassifiers.ethnicity'),
        },
        {
            entityName: shared_1.genderEntityName,
            label: t('defaultClassifiers.gender'),
        },
        {
            entityName: shared_1.regionEntityName,
            label: t('defaultClassifiers.region'),
        },
        // please keep this list sorted
    ], [t]);
}
exports.useDefaultClassifierConfigurationTransferParams = useDefaultClassifierConfigurationTransferParams;
